import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import LatestGrid from './components/LatestGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedGrid />
        <LatestGrid />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}